import App from 'next/app'
import { logVitals } from '@/components/Sitewide/webVitals'

// These were ambiguous-build-order global imports I am consolidating here
// For the PLP page (including search, yes i know it's misnamed)
import '@/styles/category.css'
// base normalization of HTML and BODY nodes
import '@/components/Checkout/normalize.css' // RISKY ONE...
import '@/styles/extend.scss'
// These are global, though COULD be modules, and classnames non-intersecting.
import '@/components/Search/SearchNotFound.scss' // less risky now, not a module but also not global namespace

// Iffy on how to achieve this one...?
import 'react-rater/lib/react-rater.css'

// These are global SCSS, just like the CSS ones above...
import '@/styles/cart.scss'
import '@/styles/header.scss'
import '@/styles/tailwind.scss'

// These are local files, with global imports - I am taking
//   a shot at resolving them to parent...
import '@/components/Pdp/AddProductToCartForm/style.scss'
import '@/components/Pdp/ProductImagesCarousel/style.scss'
import '@/components/Pdp/AccordionProductDetails/style.scss'
import '@/components/Content/CarouselWithCopy/styles.scss'
import '@/components/Content/CollectionCarousel/styles.scss'
import '@/components/Sitewide/Navbar/InvespMenuScripts/FullWidthMenu/style.scss'
import '@/components/Sitewide/Navbar/InvespMenuScripts/SecondNavMenu/style.scss'
import '@/components/Sitewide/Navbar/InvespMenuScripts/HamburgerMenu/style.scss'
import '@/components/Sitewide/Navbar/InvespMenuScripts/StickyTopNavigationDesktop/style.scss'
import '@/components/Sitewide/Navbar/InvespMenuScripts/StickyTopNavigationMobile/style.scss'

class AppWithSystemwideAsyncData extends App {
  componentDidMount() {
    try {
      logVitals()
    } catch {
      // fail silently
    }
  }
}

export default AppWithSystemwideAsyncData
